import angular from 'angular';
import moment from 'moment';
import SubEntity from "../seller/sub-entity.data";

(function () {
    'use strict';
    angular.module('app.core').factory('InvBuyerSubEntityRelation', InvBuyerSubEntityRelationData);

    InvBuyerSubEntityRelationData.$inject = ['$translate'];

    /* @ngInject */
    function InvBuyerSubEntityRelationData($translate) {
        InvBuyerSubEntityRelation.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getLegalEntityStatus: getLegalEntityStatus,
            getSubEntityStatus: getSubEntityStatus,
            getLegalEntityIdentifiant: getLegalEntityIdentifiant,
            dateAcceptationForm: dateAcceptationForm,
            dateEndOfValidityForm: dateEndOfValidityForm,
            hasFormError:hasFormError,
        };

        function InvBuyerSubEntityRelation(invBuyerSubEntityRelationData) {
            if (!invBuyerSubEntityRelationData) {
                this.buildEmpty();
            } else {
                this.build(invBuyerSubEntityRelationData);
            }
        }

        return InvBuyerSubEntityRelation;

        function buildEmpty() {
            this.subEntity = new SubEntity();
            this.invitedBuyerStatus = null;
            this.dateAcceptation = null;
            this.dateEndOfValidity = null;
            this.codeErp = null;
            this.cooperativeName = null;
        }

        function build(relationData) {
            this.subEntity = new SubEntity(relationData.subEntity);
            this.invitedBuyerStatus = relationData.invitedBuyerStatus || null;
            this.dateAcceptation = relationData.dateAcceptation || null;
            this.dateEndOfValidity = relationData.dateEndOfValidity || null;
            this.codeErp = relationData.codeErp || null;
            this.cooperativeName = relationData.cooperativeName || null;
        }

        function getLegalEntityStatus() {
            if (this.invitedBuyerStatus) {
                return $translate.instant('subInvited_entity_relation.buyer_legalEntity_statut.' + angular.lowercase(this.invitedBuyerStatus));
            }
        }

        function getSubEntityStatus() {
            if(this.subEntity.status) {
                return $translate.instant('kiss_seller.edit.sub_entity.statuses.' + this.subEntity.status);
            }
        }

        function getLegalEntityIdentifiant() {
            var id = '';
            if (this.subEntity.legalEntity.idFiscal) {
                id = this.subEntity.legalEntity.idFiscal;
            } else if (this.subEntity.legalEntity.idNational) {
                id = this.subEntity.legalEntity.idNational;
            }
            return id;
        }

        function dateAcceptationForm() {
            if(this.dateAcceptation) {
                return moment(this.dateAcceptation).format('DD/MM/YYYY');
            }
        }

        function dateEndOfValidityForm() {
            if(this.dateEndOfValidity) {
                return moment(this.dateEndOfValidity).format('DD/MM/YYYY');
            }
        }
        function hasFormError(){
            return this.subEntity.status==='DISCARDED'  ;
               
        }
    }
})();
